import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const CompanySkeleton = () => {
  return (
    <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2">
      <Card className="lg:col-span-2">
        <CardContent className="px-3 py-6">
          <Skeleton className="mb-6" style={{ width: "60%", height: "48px" }} />

          <div className="grid grid-cols-3 gap-4">
            {Array.from({ length: 5 }).map((_, index) => (
              <Skeleton key={index} style={{ width: "100%", height: "46px" }} />
            ))}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="px-3 py-6">
          <h3 className="mb-4 text-xl font-semibold text-[#13171B]">
            Descripción
          </h3>

          <div className="grid grid-cols-2 gap-4">
            {Array.from({ length: 5 }).map((_, index) => (
              <Skeleton key={index} style={{ width: "100%", height: "60px" }} />
            ))}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="px-3 py-6">
          <div className="mb-4 flex items-center gap-4">
            <h3 className="grow text-xl font-semibold text-[#13171B]">
              Usuarios
            </h3>
          </div>

          <div className="flex flex-col gap-2">
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} style={{ width: "100%", height: "28px" }} />
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CompanySkeleton;
